import { Component, Input, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ClientNotesServices } from '../../../@theme/services/notes.service'

import { DatePipe } from '@angular/common'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, EditCommandDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { State } from '@progress/kendo-data-query'
import { ClientNote } from './model'

@Component({
    selector: 'gd-rep-editor-log',
    templateUrl: './viewaccountnotes.component.html',
    imports: [
        GridComponent,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ColumnComponent,
        CellTemplateDirective,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        DatePipe,
    ]
})
export class ViewAccountNotesComponent implements OnInit {
  clientidpasseddef: number
  get clientidpassed(): number {
    return this.clientidpasseddef
  }
  @Input() set clientidpassed(value: number) {
    this.clientidpasseddef = value
  }
  @Input() accountname: any

  public view: any = []
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10,
  }
  public formGroup: UntypedFormGroup

  private editService: ClientNotesServices
  private editedRowIndex: number

  constructor(
    private cliservice: ClientNotesServices,
    formBuilder: UntypedFormBuilder,
  ) {
    /*   const param = { clientId: this.clientidpasseddef }
    this.cliservice.GetClientNotesforviewaccountspg(param).subscribe(r => {
       this.view = r;
     }) */
  }
  Retrievedate() {
    const param = { clientId: this.clientidpasseddef }
    this.cliservice.GetClientNotesforviewaccountspg(param).subscribe((r) => {
      this.view = r
    })
  }
  ngOnInit() {
    this.Retrievedate()
  }
  public addHandler({ sender }) {
    this.closeEditor(sender)

    this.formGroup = new UntypedFormGroup({
      clientNoteId: new UntypedFormControl(),
      note: new UntypedFormControl('', Validators.required),
      clientId: new UntypedFormControl(0),
      EnteredByRep: new UntypedFormControl(false),
    })

    sender.addRow(this.formGroup)
  }

  public editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender)

    this.formGroup = new UntypedFormGroup({
      clientNoteId: new UntypedFormControl(dataItem.clientNoteId),
      note: new UntypedFormControl(dataItem.Note, Validators.required),
      clientId: new UntypedFormControl(dataItem.ClientID),
      EnteredByRep: new UntypedFormControl(false),
    })
    this.editedRowIndex = rowIndex

    sender.editRow(rowIndex, this.formGroup)
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }) {
    formGroup.value.clientId = this.clientidpasseddef
    if (formGroup.value.clientNoteId === null) {
      formGroup.value.clientNoteId = 0
    }
    const product: ClientNote = formGroup.value
    const param = { clientnotedata: product }
    this.cliservice.SubmitclientNotesforviewaccountspg(param).subscribe((c) => {
      this.Retrievedate()
    })

    sender.closeRow(rowIndex)
  }

  public removeHandler({ dataItem }) {
    this.editService.remove(dataItem)
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex)
    this.editedRowIndex = undefined
    this.formGroup = undefined
  }
}
